import { PKG_ERROR_TYPES } from '@/components/Packages/errorTypes'

import { PKG_HOTEL_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA_SETI } from './pkg-session-recovery'

const LISTINGS_REROUTE_SETI_BY_MESSAGE: Record<string, string> = {
  [PKG_ERROR_TYPES.HOTEL_LISTINGS_REROUTE_ERROR]: PKG_HOTEL_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA_SETI,
  [PKG_ERROR_TYPES.FLIGHT_LISTINGS_REROUTE_ERROR]: 'PKG_FLY_LISTINGS_ERROR_PERSIST_SEARCH_CRITERIA',
}

export type FireHotelListingsRerouteImpressionIfFinalParams = {
  /** Prefer `(code) => pclnExperimentation.fireImpression(code)` so `this` is preserved. */
  fireImpression: (experimentCode: string) => void
  redirectSource: string | string[] | undefined
  message: string | string[] | undefined
  /** True when vacationpackages will `router.replace` to `/shop/search` — pkg-search owns the impression then. */
  willHandOffToShopSearch: boolean
}

/**
 * Fires the listings-error persist SETI when this page is the final stop for a
 * hotel or flight listings error redirect. No SETI state check — the listings
 * app already gated VARIANT. Advanced search hands off to pkg-search, which owns
 * that impression.
 */
export function fireHotelListingsRerouteImpressionIfFinal({
  fireImpression,
  redirectSource,
  message,
  willHandOffToShopSearch,
}: FireHotelListingsRerouteImpressionIfFinalParams): void {
  const isRedirectSourceError = typeof redirectSource === 'string' && redirectSource.toLowerCase() === 'error'
  if (!isRedirectSourceError) {
    return
  }

  const experimentCode = typeof message === 'string' ? LISTINGS_REROUTE_SETI_BY_MESSAGE[message] : undefined
  if (!experimentCode) {
    return
  }

  if (willHandOffToShopSearch) {
    return
  }

  fireImpression(experimentCode)
}
